export default __webpack_public_path__ + "4378ab437cddfc2bbb71d99ec1d52202.woff2";